<div class="card" (click)="cardClicked.emit()" *ngIf="employee">
    <div class="card-body p-2">
        <div class="flex flex-row items-center gap-2">
            <app-employee-avatar
                [employeeId]="employee.registeredEmployeeId"
                [initials]="initials"
                avatarClasses="w-[64px]"
            ></app-employee-avatar>

            <div class="flex flex-col">
                <h4 class="mb-0">{{ employee.firstName }} {{ employee.lastName }}</h4>
                <div class="text-sm flex items-center gap-2 relative my-1">
                    <a class="link link-hover text-primary" [routerLink]="[companyUrl$ | ngrxPush, 'addresses']">{{
                        (company$ | ngrxPush)?.companyNumber
                    }}</a>
                    <button
                        (mouseenter)="showCompanyNumberToolTip()"
                        (mouseleave)="hideTooltip()"
                        (click)="copyCompanyNumber(company)"
                        class=""
                    >
                        <iota-icon *ngIf="!showCheckedIcon" icon="link"></iota-icon>
                        <iota-icon
                            *ngIf="showCheckedIcon"
                            icon="check-circle"
                            size="1"
                            class="bg-primary rounded-full text-white"
                        ></iota-icon>
                        <span
                            *ngIf="showTooltip"
                            class="whitespace-nowrap absolute -top-6 left-16 rounded-lg px-1 py-0.5 text-xs bg-neutral text-base-100"
                        >
                            {{ tooltipText }}
                        </span>
                    </button>
                </div>
                <span *ngIf="company$ | ngrxPush" class="text-sm">{{ (company$ | ngrxPush)?.name }}</span>

                <div class="badge badge-error badge-outline mb-1" *ngIf="employee.leavingDate">
                    <span i18n>Leaving date</span>:&nbsp;{{ employee.leavingDate | date: 'dd.MM.yyyy' }}
                </div>
                <div class="badge badge-error badge-outline mb-1" *ngIf="employee.licenseEndDate">
                    <span i18n>License end</span>:&nbsp;{{ employee.licenseEndDate | date: 'dd.MM.yyyy' }}
                </div>
                <a
                    class="badge badge-error badge-outline mb-1 h-auto whitespace-normal break-words"
                    *ngIf="employee.companyTransfer as companyTransfer"
                    [routerLink]="'/employees/' + companyTransfer.transferredToRegisteredEmployeeId"
                    target="_blank"
                >
                    <span i18n>Transferred to new employee on {{ companyTransfer.transferDate | date: 'dd.MM.yyyy' }}</span>
                </a>
            </div>
        </div>

        <table class="table table-compact w-full max-w-full text-sm" *ngIf="displayAdditionalInfo">
            <tbody>
                <tr>
                    <th>chæmp-ID:</th>
                    <td class="break-words whitespace-pre-wrap">{{ employee.chaempId }}</td>
                </tr>

                <tr>
                    <th i18n>E-Mail:</th>
                    <td class="break-words whitespace-pre-wrap">{{ employee.email }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
